module.exports = __webpack_public_path__ + "img/login.e5644525.jpg";